import { TOP_LEVEL_NAV_OPTIONS } from '@/constants/nav';
import { isAgentToolkitDiscoverable } from '@/guides/agent-toolkit/multi-agent/atk-entitlement';

// the same pre-launch gate as the Go-to-page quick link (isAgentToolkitDiscoverable)
export function isAgentToolkitNavHidden (viewer = {}) {
    return !isAgentToolkitDiscoverable(viewer);
}

// No hasRedirect: the landing is visible to every user so admins can enable the toolkit
// from its splash (APP-168811); the interior agent routes still carry the admin + flag gate
export function buildPendoForAgentsNavItem ({ t, ...viewer }) {
    if (isAgentToolkitNavHidden(viewer)) {
        return [];
    }

    return [{
        name: TOP_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        title: t('sideNav.agentToolkit.Agent Toolkit'),
        iconComponent: 'AgentToolkitNavIcon',
        suffixIcon: false,
        route: { name: 'AgentToolkit' },
        pendoAnalytics: 'agent-toolkit-nav-item',
        tag: {
            type: 'beta',
            size: 'small',
        },
    }];
}
